import { render, staticRenderFns } from "./paySuccess.vue?vue&type=template&id=71c945b2&scoped=true"
import script from "./paySuccess.vue?vue&type=script&lang=ts"
export * from "./paySuccess.vue?vue&type=script&lang=ts"
import style0 from "./paySuccess.vue?vue&type=style&index=0&id=71c945b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c945b2",
  null
  
)

export default component.exports